// Recovered compiled webpack factory 57150. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return i;
      },
    }));
  let n = r(95155),
    a = r(15860),
    o = {
      error: {
        fontFamily:
          'system-ui,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"',
        height: "100vh",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      },
      text: { fontSize: "14px", fontWeight: 400, lineHeight: "28px", margin: "0 8px" },
    },
    i = function (e) {
      let { error: t } = e,
        r = null == t ? void 0 : t.digest;
      return (0, n.jsxs)("html", {
        id: "__next_error__",
        children: [
          (0, n.jsx)("head", {}),
          (0, n.jsxs)("body", {
            children: [
              (0, n.jsx)(a.HandleISRError, { error: t }),
              (0, n.jsx)("div", {
                style: o.error,
                children: (0, n.jsxs)("div", {
                  children: [
                    (0, n.jsxs)("h2", {
                      style: o.text,
                      children: [
                        "Application error: a ",
                        r ? "server" : "client",
                        "-side exception has occurred while loading ",
                        window.location.hostname,
                        " (see the",
                        " ",
                        r ? "server logs" : "browser console",
                        " for more information).",
                      ],
                    }),
                    r ? (0, n.jsx)("p", { style: o.text, children: "Digest: " + r }) : null,
                  ],
                }),
              }),
            ],
          }),
        ],
      });
    };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
